// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Braces as RawBraces } from "lucide-react";
export const Braces = /* @__PURE__ */ createIcon(RawBraces, "Braces", 2);
